<template>
    <div>
        <my-search
        v-model="pgData"
        @search="reloadHandler"
        time-start-placeholder="发出时间早至"
        time-end-placeholder="发出时间晚至"
        >
            <template slot="title">
                <el-form-item>
                    <el-input
                    v-model="pgData.proKey"
                    placeholder="项目名称"
                    clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                    v-model="pgData.txtkey"
                    placeholder="邀请书名称"
                    clearable></el-input>
                </el-form-item>
            </template>

            <template slot="btn">
                <my-btn type="new" @click="addHandler()">添加邀请书</my-btn>
            </template>
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="邀请书名称" prop="yqsname" fixed min-width="200">
                <template slot-scope="scope">
                    <el-button type="text" @click="detailHandler({id:scope.row.yqscode})" v-if="scope.row.shbj=='1'||scope.row.shbj=='9'">
                        {{scope.row.yqsname}}
                    </el-button>
                    <div v-else>
                        {{scope.row.yqsname}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="招标项目名称" prop="zbproname" min-width="220"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="邀请单位名称" prop="yqdwname" min-width="160"></el-table-column>
            
            <el-table-column label="文件获取时间" prop="wjhqtime" min-width="160" v-if="isXt==0||isXt==undefined"></el-table-column>
            <el-table-column label="文件递交截止时间" prop="wjdjjztime" min-width="160" v-if="isXt==0||isXt==undefined"></el-table-column>
            <el-table-column label="回函截止时间" prop="hhjztime" min-width="160"></el-table-column>
            <el-table-column label="发出时间" prop="tbyqfctime" min-width="160"></el-table-column>

            <el-table-column label="推送状态" width="100" v-if="isXt==1&&isxt==true">
                <template slot-scope="scope">
                    <push-state :row="scope.row" :model="model"></push-state>
                </template>
            </el-table-column>
            <el-table-column label="发布状态" width="100">
                <template slot-scope="scope">
                    
                    <sh-state :row="scope.row"></sh-state>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="260" fixed="right">
                <template slot-scope="scope">
                    <btns-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        :model="{...model,iszj,procode_encrypt,isXt}"
                        @del="delHandler(scope.row.yqscode)"
                    ></btns-list>
                </template>
            </el-table-column>
        </my-table>
                                   
        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :after-query="firstData"
            :action="`${getGetters('bidUrl')}/FangAn/TbYqs/get_list.json`" v-if="isXt==0||isXt==undefined"> 
        </my-pagination>
        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :after-query="firstData"
            :action="`${getGetters('bidUrl')}/FangAn/TbYqs/xingtai/get_list.json`" v-if="isXt==1"> 
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import PushState from './components/push-state'

import ShState from './components/sh-state'
import BtnsList from './components/btns-list'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {  ShState, BtnsList,PushState },
    data() {
        return {
            pgData: {
                procode: this.getQuery('procode'),  
                txtkey:''
            },
            model: {},  
            iszj:'',
            isxt:'',
            procode_encrypt:'',
            extzsfs:''
        }
    },
    computed: {
        procode() {
            return this.getQuery('procode');
        },
        isXt() {
            return this.getQuery('isXt');
        },
    },
    methods: {
        firstData(table){
             console.log(this.extzsfs)
            var that = this
            table.forEach(function (item){
                console.log(that.extzsfs)
                if(that.extzsfs=='资格预审'&&that.iszj){
                    if(item.yqscode!=null&&item.yqscode!=""){
                        $.get(`${that.getGetters('bidUrl')}/FangAn/TbYqs/getstatus.json?`, {
                            yqscode:item.yqscode,
                            t:Math.random()
                        }, data => {
                        console.log(data)
                           that.$set(item,'proxx',data.t)

                        });
                    }
                }
                else {
                    that.$set(item,'proxx',true)
                }  
            })
            console.log(table)
        },
        addHandler() {
            this.goto({
                path:'./form',
                query:{
                    procode:this.getQuery('procode'),
                    isXt:this.isXt
                },
            }); 
        },
        delHandler(yqscode){
            if(this.isXt==0||this.isXt==undefined) {
                this.$post(`${this.getGetters('bidUrl')}/FangAn/TbYqs/del`,
                    {
                        id:yqscode
                    }, (data, res) => {
                        ShowMsg(res.msg,'success');
                        this.reloadHandler();
                });
            }
            if(this.isXt==1) {
                this.$post(`${this.getGetters('bidUrl')}/FangAn/TbYqs/xingtai/del`,
                    {
                        id:yqscode
                    }, (data, res) => {
                        ShowMsg(res.msg,'success');
                        this.reloadHandler();
                });
            }
            
        }

    },
    created() {
        if(this.isXt==0||this.isXt==undefined) {
            this.jspInit(`${this.getGetters('bidUrl')}/FangAn/TbYqs/list.json`, {
                procode: this.getQuery('procode'),
            }, data => {
                this.jspDataInit(data, ['model']);
                this.extzsfs=data.model.extzsfs
                console.log(this.extzsfs)
                this.iszj=data.iszj
                this.procode_encrypt=data.procode
            });
        }
        if(this.isXt==1) {
            this.jspInit(`${this.getGetters('bidUrl')}/FangAn/TbYqs/xingtai/list.json`, {
                procode: this.getQuery('procode'),
            }, data => {
                this.jspDataInit(data, ['model']);
                this.extzsfs=data.model.extzsfs
                console.log(this.extzsfs)
                this.isxt=data.isxt
                this.iszj=data.iszj
                this.procode_encrypt=data.procode
            });
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
